<mat-form-field class="cx-digits-3">
  <cx-number-input [formControl]="formControl" (debouncedChange)="onValueChange($event)" [disabled]="documentsDisabled">
  </cx-number-input>
</mat-form-field>


